import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

 var swiper = new Swiper(".mySwiper", {
    speed:700,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

$(".section9 .download").click(function() {
    $(".download-pop").show();
})

$(".download-pop .out").click(function() {
    $(".download-pop").hide();
})